import React, { lazy, Suspense } from "react";

const StaffManagementPage = lazy(() => import("./staff-management-page"));

const StaffAttendancePage = () => (
    <Suspense fallback={null}><StaffManagementPage screen="attendance" /></Suspense>
);

export default StaffAttendancePage;
